import {hasValue, withErrors, withEventDispatcher, withIcon, withPlaceholder} from "./input.mixin";

export default {
  name: 'input.class',
  mixins: [hasValue('content'), withErrors, withIcon, withPlaceholder, withEventDispatcher],
  data () {
    return {
      content: ''
    }
  },
  methods: {
    focusRef () {
      this.$refs.input.focus();
      this.updateValue(this.content);
    },
    _computeErrors () {
      if ((typeof this.computeErrors === 'function')) {
        this.computeErrors();
      }
      this.$emit('compute-errors', this.content);
    },
    updateValue (value) {
      this.content = value;
      this.$emit('input', value);
      if (this.useDynamicErrors) {
        this._computeErrors();
        return;
      }
      if (this.usePseudoDynamicErrors && this.hasError) {
        this._computeErrors();
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/mixins/input.class.js